module.exports = __webpack_public_path__ + "media/applicants/prepare-orders-90638759.svg";